/**
 * The TAPS 2 screening segment's step ids, in flow order. Every question in
 * the member's chain is asked on this one page, so the address is the same
 * however many questions their main program has: a page only some programs
 * reach would tell anyone reading page views which program the member picked.
 * Kept free of imports so the step list can include it without a cycle.
 */
export const SCREENING_STEPS = ['screening'] as const;

export type ScreeningStepId = (typeof SCREENING_STEPS)[number];

/** The last id in the segment; leaving it hands off to whatever step follows. */
export const LAST_SCREENING_STEP: ScreeningStepId = 'screening';
